<template>
    <div>
        <v-dialog v-model="dialog" class="w-full md:w-1/2">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }} {{ editedItem.pers_fname }} {{ editedItem.pers_lname }}</span>
                    <v-spacer></v-spacer>
                    <v-icon @click="close">mdi-close</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="px-2">
                        <div class="flex flex-wrap justify-between content-center -mx-2 p-8">
                            <div class="w-full md:w-1/4 px-2">
                                <v-text-field outlined v-model="editedItem.pers_fname" label="Last Name" hint="Last Name"></v-text-field>
                            </div>
                            <div class="w-full md:w-1/4 px-2">
                                <v-text-field outlined v-model="editedItem.pers_lname" label="First Name" hint="First Name"></v-text-field>
                            </div>
                            <div class="w-full md:w-1/4 px-2">
                                <v-text-field outlined v-model="editedItem.uin" label="UIN" hint="UIN"></v-text-field>
                            </div>
                            <div class="w-full md:w-1/4 px-2">
                                <v-select :items="dropdownDontDeleteOption" outlined v-model="editedItem.dont_delete" item-text="text" item-value="value" label="Dont Delete"></v-select>
                            </div>
                            <div class="w-full md:w-1/4 px-2">
                                <v-select :items="dropdownPayrollOptions" outlined v-model="editedItem.can_payroll" item-text="text" item-value="value" label="Can Payroll?"></v-select>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="close"><v-icon>mdi-close</v-icon>Cancel</v-btn>
                    <v-btn :loading="loadingSubmitButton" color="success" @click="save"><v-icon>mdi-check</v-icon>Submit</v-btn>
                </v-card-actions>>
            </v-card>
        </v-dialog>

        <v-card raised>
            <v-card-title>
                Faculty Staff Users
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-btn color="primary" @click="dialog = true">Add Faculty/Staff User</v-btn>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :loading="loadingFacultyStaffUsers" :headers="headers" :items="facultyStaffUsers" :search="search" class="elevation-1">
                    <template v-slot:item.action="{ item }">
                        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
                appURL: process.env.MIX_APP_URL,
                loadingFacultyStaffUsers: false,
                loadingSubmitButton: false,
                facultyStaffUsers: [],
                dialog: false,
                snack: false,
                snackColor: '',
                snackText: '',
                headers: [
                    { text: 'UIN', align: 'left', sortable: true, value: 'uin',},
                    { text: 'First Name', value: 'pers_fname' },
                    { text: 'Last Name', value: 'pers_lname' },
                    { text: 'Manual Input', value: 'dont_delete' },
                    { text: 'Can Payroll?', value: 'can_payroll' },
                    { text: 'Actions', value: 'action', sortable: false },
                ],
                editedIndex: -1,
                editedItem: {
                    uin: '',
                    pers_fname: '',
                    pers_lname: '',
                    dont_delete: '',
                    can_payroll: '',
                },
                defaultItem: {
                    uin: '',
                    pers_fname: '',
                    pers_lname: '',
                    dont_delete: '',
                    can_payroll: '',
                },
                dropdownDontDeleteOption: [
                    {text: 'Yes', value: 'Y'},
                    {text: 'No', value: 'N'},
                ],
                dropdownPayrollOptions: [
                    {text: 'Yes', value: 'Y'},
                    {text: 'No', value: 'N'},
                ]
            }
        },
        created() {
            this.fetchFacultyStaffUsers();
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Item' : 'Edit'
            },
        },
        methods: {
            fetchFacultyStaffUsers: function () {
                this.loadingFacultyStaffUsers = true;
                axios.get(this.appURL + '/api/facultystaffusers')
                .then((response) => {
                    if(response.status === 200)
                    {
                        this.facultyStaffUsers = response.data;
                    }
                    this.loadingFacultyStaffUsers = false;
                })
                .catch(error => {
                    console.log(error);
                    this.loadingFacultyStaffUsers = false;
                });
            },
            save: function() {
                if (this.editedIndex > -1) {
                    //Update
                    this.loadingSubmitButton = true;
                    axios.post(this.appURL + '/api/facultystaffusers/' + this.editedItem.uin, {
                        _method: 'patch',
                        uin: this.editedItem.uin,
                        pers_fname: this.editedItem.pers_fname,
                        pers_lname: this.editedItem.pers_lname,
                        dont_delete: this.editedItem.dont_delete,
                        can_payroll: this.editedItem.can_payroll,
                    }).then((response) => {
                        if(response.status === 200)
                        {
                            Object.assign(this.facultyStaffUsers[this.editedIndex], this.editedItem);
                            this.snack = true;
                            this.snackColor = 'success';
                            this.snackText = 'Successfully Updated';
                        }
                        else {
                            this.snack = true;
                            this.snackColor = 'error';
                            this.snackText = 'Oops! Something went wrong!';
                        }
                        this.loadingSubmitButton = false;
                        this.close()
                    }).catch(error => {
                        this.snack = true;
                        this.snackColor = 'error';
                        this.snackText = 'Oops! Something went wrong!'
                        this.loadingSubmitButton = false;
                        this.close()
                    });
                } else {
                    //Save
                    this.loadingSubmitButton = true;
                    axios.post(this.appURL + '/api/facultystaffusers/', {
                        uin: this.editedItem.uin,
                        pers_fname: this.editedItem.pers_fname,
                        pers_lname: this.editedItem.pers_lname,
                        dont_delete: this.editedItem.dont_delete,
                        can_payroll: this.editedItem.can_payroll,
                    }).then((response) => {
                        if(response.status === 200)
                        {
                            this.facultyStaffUsers.push(this.editedItem);
                            this.snack = true;
                            this.snackColor = 'success';
                            this.snackText = 'Successfully Updated';
                        }
                        else {
                            this.snack = true;
                            this.snackColor = 'error';
                            this.snackText = 'Oops! Something went wrong!';
                        }
                        this.loadingSubmitButton = false;
                        this.close()
                    }).catch(error => {
                        this.snack = true;
                        this.snackColor = 'error';
                        this.snackText = 'Oops! Something went wrong!'
                        this.loadingSubmitButton = false;
                        this.close()
                    });
                }
            },
            editItem (item) {
                this.editedIndex = this.facultyStaffUsers.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            close () {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300)
            },
        }
    }
</script>
